import { cn } from '@/lib/utils';

export const SIMILARITY_HIGH_THRESHOLD = 0.85;

function similarityChipClass(score: number): string {
    if (score >= SIMILARITY_HIGH_THRESHOLD) {
        return 'bg-green-500/20 text-green-400';
    }
    return 'bg-yellow-500/20 text-yellow-400';
}

interface SimilarityChipProps {
    score: number;
}

export function SimilarityChip({ score }: SimilarityChipProps) {
    return (
        <span
            className={cn(
                'shrink-0 rounded px-1.5 py-0.5 text-xs font-medium',
                similarityChipClass(score),
            )}
        >
            {Math.round(score * 100)}%
        </span>
    );
}
